<template>
	<div class="container">
		<b-overlay
			:show="loading"
			rounded="sm"
		>
			<h1 class="border-bottom d-flex mb-5">
				<span class="mr-auto">{{ header }}</span>
				<button
					class="btn btn-link"
					v-if="!edit"
					@click="edit = true"
				>
					<b-icon icon="pencil"></b-icon>
				</button>
				<span v-else>
					<button
						class="btn btn-link mr-3 text-success"
						@click="save"
						:disabled="Object.keys(changeset).length == 0"
					>
						<b-icon icon="check2"></b-icon>
					</button>
					<button
						class="btn btn-link text-danger"
						@click="edit = false"
					>
						<b-icon icon="x"></b-icon>
					</button>
				</span>
			</h1>
			<div class="row">
				<div class="col-md-6">
					<FieldGroupCard
						:edit="edit"
						:fields="BREED_BASE_FIELDS_FLAT"
						:record="record"
						title="Breed base details"
						@change="onChange"
					/>
				</div>
				<div class="col-md-6" v-if='record.species == "dog"'>
					<FieldGroupCard
						:edit="edit"
						:fields="BREED_DOG_FIELDS_FLAT"
						:record="record"
						title="Dog details"
						@change="onChange"
					/>
				</div>
				<div class="col-md-6">
					<FieldGroupCard
						:edit="edit && sharedState.user.info.roles.includes('admin')"
						:fields="AUDIT_GROUPLESS_FIELDS_FLAT"
						:record="record"
						title="Audit"
						@change="onChange"
					/>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import apiClient from '@/apiClient'
import FieldGroupCard from '@/components/FieldGroupCard'
import { BREED_FIELDS_FLAT, BREED_BASE_FIELDS_FLAT, BREED_DOG_FIELDS_FLAT } from '@/fields/breed_fields'
import { AUDIT_GROUPLESS_FIELDS_FLAT } from '@/fields/audit_fields'
import { readFieldFlat } from '@/util'

export default {
	components: { FieldGroupCard },
	data() {
		return {
			BREED_FIELDS_FLAT,
			BREED_BASE_FIELDS_FLAT,
			BREED_DOG_FIELDS_FLAT,
			AUDIT_GROUPLESS_FIELDS_FLAT,
			changeset: {},
			edit: false,
			loading: false,
			record: {},
		}
	},
	computed: {
		header() {
			const { name_en, species } = this.record
			const { id } = this.$route.params
			return name_en
				? `${name_en} (${species})`
				: id
		},
	},
	methods: {
		readFieldFlat,
		async fetchRecord() {
			this.loading = true
			this.record = await apiClient.breedView(
				this.$route.params.id,
				true
			)
			this.loading = false
		},
		onChange(fieldWithValue) {
			console.log('onchange', fieldWithValue)
			const f = fieldWithValue.field
			const oldValue = readFieldFlat(this.record, f)
			const newValue = fieldWithValue.value
			if (oldValue !== newValue) {
				this.$set(this.changeset, f, newValue)
			} else {
				this.$delete(this.changeset, f)
			}
		},
		async save() {
			this.loading = true
			if (Object.keys(this.changeset).length > 0) {
				await apiClient.breedEdit(
					Object.assign({ id: this.$route.params.id }, this.changeset)
				)
			}
			this.edit = false
			await this.fetchRecord() // TODO we need this extra call because /animal/edit does not humanize
			this.loading = false
		},
	},
	watch: {
		$route(to, from) {
			this.fetchRecord()
		},
	},
	mounted() {
		this.fetchRecord()
	},
}
</script>
